import { CATEGORY } from 'constants/Levels';
import { bulkUpload } from 'constants/validationMessages';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IStore } from 'reducers/index';
import { INickname } from 'reducers/nickname';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import templateImportNew from './IMPORT_BULK_UPLOAD_3.00.xlsx';
import templateImport_Athena from './IMPORT_BULK_UPLOAD_ATHENA_WITHOUT_VAT_PARTNER.xlsx';
import templateImportNew_vatPartner from './IMPORT_BULK_UPLOAD_VAT_PARTNER_3.00.xlsx';
import templateImport_Athena_VatPartner from './IMPORT_BULK_UPLOAD_ATHENA_WITH_VAT_PARTNER.xlsx';
import templateExportNew from './EXPORT_BULK_UPLOAD_3.00.xlsx';
import templateExport_Athena from './EXPORT_BULK_UPLOAD_ATHENA_WITHOUT_VAT_PARTNER.xlsx';
import templateExportNew_vatPartner from './EXPORT_BULK_UPLOAD_VAT_PARTNER_3.00.xlsx';
import templateExport_Athena_VatPartner from './EXPORT_BULK_UPLOAD_ATHENA_WITH_VAT_PARTNER.xlsx';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import { bulkUploadETS, bulkUploadExport } from 'actions/ets';
import { isFeatureEnabled } from 'utilities/util';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';

const SDiv = styled.div`
    margin-bottom: 15px;
`;

export interface IUpload extends IMapStateToProps, IDispatch, RouteComponentProps {
    name: string;
    refreshName: string;
    fileFormats: string;
    restrictionText: string;
    entityType: string;
    catagory: string;
}

interface IMapStateToProps {
    nickname: INickname;
    bulkUploadStatus: any;
    isFetchDataError: boolean;
    bulkUploadExportResponse: any;
    featureToggles: IFeatureToggleModel[];
    userPermissions: any;
}

interface IDispatch {
    bulkUploadETS: (exportJobId: any) => Promise<void>;
    bulkUploadExport: (exportJobId: any) => Promise<void>;
}

const _UploadSection = (props: IUpload) => {
    const [file, setFile] = useState<File>();
    const [isBulkUpload, setIsBulkUpload] = useState(false);
    const [isBulkRefresh, setIsBulkRefresh] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [type, setType] = useState('');
    const isVatPartnerAmendmentAllowed = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ENABLE_VATPARTNER_AMENDMENT, props.featureToggles);
    const isAthenaAmendmentAllowed = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_AUTO_PRICE_RETRIEVAL_FROM_ATHENA, props.featureToggles);
    const isBulkRefreshAllowed = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ATHENA_BULK_UPLOAD_REFRESH, props.featureToggles);

    useEffect(() => {
        if (props.bulkUploadStatus && props.bulkUploadStatus.isValid === true && props.entityType === 'FinOpsImport') {
            setIsUploading(false);
            setFile(undefined);
            setIsBulkUpload(false);
            setErrorMsg(bulkUpload.Success_Msg);
            setShowDialog(true);
            setType('success');
        }
        if (props.isFetchDataError) {
            setIsUploading(false);
            setFile(undefined);
            setIsBulkUpload(false);
            setType('failed');
            setErrorMsg(bulkUpload.Error_Msg);
            setShowDialog(true);
        }
    }, [props.bulkUploadStatus, props.isFetchDataError]);

    useEffect(() => {
        if (props.bulkUploadExportResponse && props.bulkUploadExportResponse !== '') {
            setIsUploading(false);
            setFile(undefined);
            setIsBulkUpload(false);
            setErrorMsg(bulkUpload.Success_Msg);
            setShowDialog(true);
            setType('success');
        }
        if (props.isFetchDataError) {
            setIsUploading(false);
            setFile(undefined);
            setIsBulkUpload(false);
            setType('failed');
            setErrorMsg(bulkUpload.Error_Msg);
            setShowDialog(true);
        }
    }, [props.bulkUploadExportResponse, props.isFetchDataError]);

    useEffect(() => {
        setShowDialog(false);
    }, []);

    const generateTemplateLinks = () => {
        const templateVersion = props.entityType === 'FinOpsImport' ? '3.00' : '3.00';
        const downloadLink = props.entityType === 'FinOpsImport' ? 'finops_charges_bulk_upload_template_Import' : 'finops_charges_bulk_upload_template_Export';

        // Map feature flag combinations to templates using a single object
        const templateMap = {
            both: props.entityType === 'FinOpsImport' ? templateImport_Athena_VatPartner : templateExport_Athena_VatPartner,
            athena: props.entityType === 'FinOpsImport' ? templateImport_Athena : templateExport_Athena,
            vatPartner: props.entityType === 'FinOpsImport' ? templateImportNew_vatPartner : templateExportNew_vatPartner,
            none: props.entityType === 'FinOpsImport' ? templateImportNew : templateExportNew
        };

        // Determine template key based on feature flags
        const getTemplateKey = () => {
            if (isVatPartnerAmendmentAllowed && isAthenaAmendmentAllowed) {
                return 'both';
            };
            if (isAthenaAmendmentAllowed) {
                return 'athena';
            };
            if (isVatPartnerAmendmentAllowed) {
                return 'vatPartner';
            };
            return 'none';
        };

        const selectedTemplate = templateMap[getTemplateKey()];
        if (isBulkRefreshAllowed) {
            return (
                <p style={{ lineHeight: '24px' }}>
                    Refer this below template for Add/Edit/Delete (Cashbox & Athena) & Rate Refresh (Athena) : <br />{' '}
                    {(
                        <a href={selectedTemplate} download={downloadLink}>
                            <b><u>Excel template (version {templateVersion})</u></b>
                        </a>
                    )}{' '}
                    and upload in below links.
                </p>
            );
        }

        return (
            <p>
                Add multiple charges at once by filling in{' '}
                {(
                    <a href={selectedTemplate} download={downloadLink}>
                        <b><u>this Excel template (version {templateVersion})</u></b>
                    </a>
                )}{' '}
                and uploading it below
            </p>
        );
    };

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>, fieldName: string) => {
        if (e.target.files) {
            if (e.target.files.length > 0 && e.target.files[0].size > 3000000) {
                setFile(undefined);
                fieldName === props.name ? setIsBulkUpload(false) : setIsBulkRefresh(false);
                setType('failed');
                setErrorMsg(bulkUpload.Error_Msg_Size);
                setShowDialog(true);
            } else {
                setFile(e.target.files[0]);
                fieldName === props.name ? setIsBulkUpload(true) : setIsBulkRefresh(true);
            }
        }
    };

    const getMessageText = () => {
        return type === 'success' ? <div><i aria-hidden="true" className={'fas fa-check-circle fa-3x padding-right-medium'} />File successfully uploaded and submitted for processing</div> :
            <div><i aria-hidden="true" className={'fa fa-times-circle fa-3x padding-right-medium'} />File upload failed</div>;
    };

    const selectFile = (fieldName: string) => {
        const input = document.getElementById(fieldName);
        if (input) {
            input.click();
        }
    };

    const unSelectFile = (item: any) => {
        if (item) {
            const bulkUploadInput: any = document.getElementById(props.name);
            bulkUploadInput.value = '';
            const bulkRefreshInput: any = document.getElementById(props.refreshName);
            bulkRefreshInput.value = '';
        }
        setFile(undefined);
        setIsBulkUpload(false);
        setIsBulkRefresh(false);
    };

    const handleUploadClick = async (event: any, isRefresh: boolean = false) => {
        if (!file) {
            return;
        }
        setIsUploading(true);
        event.preventDefault();
        if (props.entityType === 'FinOpsImport' && !isRefresh) {
            const hasExecutePermission = props.userPermissions?.permissions?.some((permission: any) => permission.businessCapabilityName === 'FinOps (Job Costing)' &&
                permission.permission === 'Execute');
            const isFinOpsSupervisor = props.userPermissions?.userGroups?.some((userGroup: any) => userGroup.userGroupName === 'FinOps Supervisor');
            const formData = new FormData();
            formData.append('file', file);
            formData.append('fileName', file.name);
            formData.append('type', CATEGORY.ISSO);
            formData.append('uploadedBy', props.nickname.employeeId);
            formData.append('hasExecutePermission', hasExecutePermission);
            formData.append('isFinOpsSupervisor', isFinOpsSupervisor);
            setTimeout(() => {
                props.bulkUploadETS(formData);
            }, 1000);
        }
        if (props.entityType === 'FinOpsExport' && !isRefresh) {
            const formData = new FormData();
            formData.append('EntityType', props.entityType);
            formData.append('FileContent', file);
            formData.append('UserName', props.nickname.employeeId);
            setTimeout(() => {
                props.bulkUploadExport(formData);
            }, 1000);
        }
        if (isRefresh && props.entityType === 'FinOpsExport') {
            const formData = new FormData();
            formData.append('EntityType', 'FinOpsExportRefresh');
            formData.append('FileContent', file);
            formData.append('UserName', props.nickname.employeeId);
            setTimeout(() => {
                props.bulkUploadExport(formData);
            }, 1000);
        }
        if (isRefresh && props.entityType === 'FinOpsImport') {
            const formData = new FormData();
            formData.append('EntityType', 'FinOpsImportRefresh');
            formData.append('FileContent', file);
            formData.append('UserName', props.nickname.employeeId);
            setTimeout(() => {
                props.bulkUploadExport(formData);
            }, 1000);
        }
    };

    const link = <a onClick={() => { props.history.push(`/exception-management/charge-import/${props.catagory}`); }}><u>Charge Upload Logs</u></a>;

    return (
        <div className={'grid-wrapper regular-body-text'}>
            <div className="col-100">
                <div className={'download'}>
                    <div>
                        {generateTemplateLinks()}
                    </div>
                </div>
            </div>
            <div className={'upload'}>
                <div className={!isUploading && !showDialog ? '' : 'hidden'}>
                    <div className="padding-bottom-large padding-top-large">
                        <div>
                            {file &&
                                <div>
                                    <h3>Selected file for : {isBulkUpload ? 'Add/Edit' : 'Bulk Refresh'}</h3>
                                    <label className="padding-bottom-small"><span>FILE NAME : {file.name}</span>
                                        <span className="fas fa-trash-alt clear-bin" onClick={() => unSelectFile(file)} />
                                    </label>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="bulk-refresh-upload">
                        <div className="bulk-upload">
                            <h3 className="bulk-upload-title">UPLOAD FILE FOR ADD/EDIT/DELETE</h3>
                            <div className="button-group">
                                <button type="button" className="button button-transparent" disabled={isBulkRefresh} onClick={() => selectFile(props.name)}>Select file</button>
                                <input id={props.name} type="file" className="hidden" disabled={isBulkRefresh} onChange={(e) => handleFileChange(e, props.name)} accept={props.fileFormats} />
                                <button type="button" className="button button-blue" disabled={isBulkRefresh} onClick={(e) => handleUploadClick(e, false)}>Upload</button>
                            </div>
                        </div>
                        <div className="small-inactive-text padding-bottom-medium">
                            <div>Accepted file type: XLSX</div>
                            <div>Maximum file size: 3 MB</div>
                        </div>

                        {isBulkRefreshAllowed &&
                            <>
                                <div className="bulk-upload">
                                    <h3 className="bulk-upload-title">UPLOAD FILE FOR ATHENA BULK REFRESH</h3>
                                    <div className="button-group">
                                        <button type="button" className="button button-transparent" disabled={isBulkUpload} onClick={() => selectFile(props.refreshName)}>Select file</button>
                                        <input id={props.refreshName} type="file" className="hidden" disabled={isBulkUpload} onChange={(e) => handleFileChange(e, props.refreshName)} accept={props.fileFormats} />
                                        <button type="button" className="button button-blue" disabled={isBulkUpload} onClick={(e) => handleUploadClick(e, true)}>Upload</button>
                                    </div>
                                </div>
                                <div className="small-inactive-text padding-top-medium">
                                    <div>Accepted file type: XLSX</div>
                                    <div>Maximum allowed rows: 1000</div>
                                </div>
                            </>
                        }
                    </div>

                </div>
                <label className={isUploading ? 'upload-text' : 'hidden'}>Uploading file...</label>
                {!isUploading && showDialog &&
                    <label>{getMessageText()}</label>
                }
                <div>
                    {
                        showDialog && type === 'failed' &&
                        <SDiv className={`message ${type}`}>
                            <i aria-hidden="true" className="fa fa-times-circle fa-3x" />
                            <span id="message_success">{errorMsg}</span>
                        </SDiv>
                    }
                </div>
                <div>
                    <SDiv className={`message info`}>
                        <i aria-hidden="true" className={'fa fa-info-circle fa-3x'} />
                        <span id="message_success">The progress and status of adding the charges will be available in the {link} page within Exception Management</span>
                    </SDiv>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    nickname: state.nickname.userNickName,
    bulkUploadStatus: state.ets.bulkUploadStatus,
    bulkUploadExportResponse: state.ets.bulkUploadExportResponse,
    isFetchDataError: state.ets.isUploadDataError,
    featureToggles: state.featureToggle.featureToggles,
    userPermissions: state.user.userPermissions
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IDispatch => ({
    bulkUploadETS: (formData: any) => dispatch(bulkUploadETS(formData)),
    bulkUploadExport: (formData: any) => dispatch(bulkUploadExport(formData)),
});

const __SearchEts = connect<IMapStateToProps, IDispatch, {}, IStore>(mapStateToProps, mapDispatchToProps)(_UploadSection);
export const UploadSection = withRouter(__SearchEts);